import { render } from "./RatingSummarySection.vue?vue&type=template&id=a272e88a"
import script from "./RatingSummarySection.vue?vue&type=script&lang=js"
export * from "./RatingSummarySection.vue?vue&type=script&lang=js"

import "./RatingSummarySection.vue?vue&type=style&index=0&id=a272e88a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__